(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["isark-canvas-product"] && !Shopify.designMode) return;
  try {
    
  function initCanvasProduct(root = document) {
    root.querySelectorAll('[data-canvas-product]').forEach((panel) => {
      const select = panel.querySelector('[data-canvas-variant]');
      if (!select || select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        panel.querySelector('[data-canvas-price]').textContent = option.dataset.price;
        const button = panel.querySelector('[data-canvas-buy]');
        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled ? panel.dataset.unavailableLabel : panel.dataset.addLabel;
        }
        if (!option.value.startsWith('preview-')) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }
  initCanvasProduct();
  document.addEventListener('shopify:section:load', (event) => initCanvasProduct(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isark-editorial-selection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('isark-once-video')) {
    customElements.define('isark-once-video', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (this.attempted || motion.matches || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver((entries) => {
          if (this.attempted || motion.matches) return;
          if (!entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.35)) return;
          this.stopAutoplay();
          this.video.muted = true;
          this.video.play()?.catch(() => {});
        }, { threshold: 0.35 });

        this.video.addEventListener('play', () => this.stopAutoplay(), { once: true, signal });
        motion.addEventListener('change', (event) => {
          if (!event.matches) return;
          this.stopAutoplay();
          this.video.pause();
        }, { signal });
        this.observer.observe(this.video);
      }

      stopAutoplay() {
        this.attempted = true;
        this.observer?.disconnect();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isark-mobile-product"]) return;
  try {
    
const isarkSyncPreviewStyles = (frame) => {
  const head = frame.contentDocument?.head;
  if (!head || head.querySelector('[data-isark-parent-style]')) return;
  document.querySelectorAll('style, link[rel="stylesheet"]').forEach((source) => {
    const copy = source.cloneNode(true);
    copy.setAttribute('data-isark-parent-style', '');
    head.appendChild(copy);
  });
};
document.querySelectorAll('[data-isark-mobile-frame]').forEach((frame) => {
  frame.addEventListener('load', () => isarkSyncPreviewStyles(frame));
  isarkSyncPreviewStyles(frame);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
